import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { bindActionCreators } from "redux";
import { useDispatch } from "react-redux";
import {
    AppStoreIssuesState,
    IActiveAppStoreIssueResource,
} from "../types/app-store-issues";

const initialState: AppStoreIssuesState = {
    getActiveIssues: {
        issues: [],
        loading: false,
        success: false,
        error: false,
    },
};

const appStoreIssuesSlice = createSlice({
    name: "appStoreIssues",
    initialState,
    reducers: {
        getActiveIssues(state) {
            state.getActiveIssues = {
                issues: state.getActiveIssues.issues,
                loading: true,
                success: false,
                error: false,
            };
        },
        getActiveIssuesSuccess(
            state,
            action: PayloadAction<IActiveAppStoreIssueResource[]>
        ) {
            state.getActiveIssues = {
                issues: action.payload,
                loading: false,
                success: true,
                error: false,
            };
        },
        getActiveIssuesFailure(state) {
            // Clear issues on failure — keeping the previous array lets the
            // banner show resolved/outdated "action required" alerts until a
            // later poll succeeds (up to the 5-minute interval).
            state.getActiveIssues = {
                issues: [],
                loading: false,
                success: false,
                error: true,
            };
        },
        clearActiveIssues(state) {
            state.getActiveIssues = {
                issues: [],
                loading: false,
                success: false,
                error: false,
            };
        },
        startActiveIssuesPolling() {},
        stopActiveIssuesPolling() {},
    },
});

export const {
    getActiveIssues,
    getActiveIssuesSuccess,
    getActiveIssuesFailure,
    clearActiveIssues,
    startActiveIssuesPolling,
    stopActiveIssuesPolling,
} = appStoreIssuesSlice.actions;

export const mapDispatchToProps = () => {
    return bindActionCreators(
        {
            getActiveIssues,
            clearActiveIssues,
            startActiveIssuesPolling,
            stopActiveIssuesPolling,
        },
        useDispatch()
    );
};

export default appStoreIssuesSlice.reducer;
